//Styles
import '../../styles/views/load.css';

const externalLinks = require("../../data/externalLinks.json");

function View() {


    return (<section className="section-load">
    <img src={`${externalLinks.webPage}/logo512.png`} alt="logo" />
    <h1>Cargando...</h1>
    </section>);
}

export default View;
